import axios from "axios";
import { errorNotify } from "./Toast";

const Api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

Api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("tmsToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== "/" && err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        localStorage.removeItem("tmsToken");
        localStorage.removeItem("tmsUserDetail");

        errorNotify("Session expired. Please login again.");

        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);

export default Api;
